import { logger } from '../utils/logger';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { activar, findAll, get, remove, save, update } from "../services/Service";

import { Area, AreaFiltro } from "../types/Area";
import {
    addArea,
    loadDataArea,
    loadListArea,
    loadingError,
    visibleError,
    setGuardado,
    loadDataFiltro,
    areaInitial,
    areaFiltroInitial,
} from "../context/Area/AreaReducer";

export const useArea = () => {
    const BASE_URL = 'areas';
    const { loading, areaSelected, areaList, errors, error, guardado, filtro } = useSelector(
        (state: RootState) => state.area
    );

    const dispatch = useDispatch();

    const buscarAreas = async (filtroArea: AreaFiltro) => {
        const params: string[] = [];
        const nombre = filtroArea.nombre?.trim();
        if (nombre) {
            params.push(`nombre=${encodeURIComponent(nombre)}`);
        }
        if (filtroArea.activo !== null && filtroArea.activo !== '') {
            params.push(`activo=${filtroArea.activo}`);
        }
        const url = `${BASE_URL}/findBy${params.length > 0 ? '?' + params.join('&') : ''}`;

        try {
            const response = await findAll(url);
            dispatch(loadListArea(response.data));
            return response;
        } catch (error) {
            logger.log(error);
            throw error;
        }
    }

    const guardarArea = async (area: Area) => {
        let response;
        try {
            if (!area.id) {
                response = await save(BASE_URL, area);
            } else {
                response = await update(BASE_URL, area);
            }
            dispatch(addArea(response.data));
            return response;
        } catch (error: any) {
            throw error;
        }
    }

    const buscarArea = async (id: string) => {
        try {
            const response = await get(BASE_URL, id)
            dispatch(loadDataArea(response.data));
            return response.data;
        } catch (error) {
            logger.log(error);
        }
    }

    const eliminarArea = async (id: string) => {
        try {
            return await remove(BASE_URL, id);
        } catch (error) {
            logger.log(error);
            throw error;
        }
    }

    const activarArea = async (id: string) => {
        try {
            return await activar(BASE_URL, id);
        } catch (error) {
            logger.log(error);
            throw error;
        }
    }

    const handleAreaSelected = (area: Area) => {
        dispatch(loadDataArea(area))
    }
    const showError = (load: boolean) => {
        dispatch(visibleError(load))
    }
    const setMsgError = (error: string[]) => {
        dispatch(loadingError(error));
    }
    const handleGuardado = (guardado: boolean) => {
        dispatch(setGuardado(guardado))
    }
    const handleFiltroArea = (filtroArea: AreaFiltro) => {
        dispatch(loadDataFiltro(filtroArea))
    }
    return {
        buscarAreas,
        guardarArea,
        buscarArea,
        eliminarArea,
        activarArea,
        handleAreaSelected,
        showError,
        setMsgError,
        handleGuardado,
        handleFiltroArea,
        filtro,
        areaInitial,
        areaFiltroInitial,
        areaList,
        areaSelected,
        loading,
        errors,
        error,
        guardado
    }
}
